export const langObjArr = [
  { lang: 'עברית', localName: 'he', shortName: 'עב' },
  { lang: 'English', localName: 'en', shortName: 'En' },
  { lang: 'Español', localName: 'es', shortName: 'Es' },
  { lang: 'français', localName: 'fr', shortName: 'Fr' }
]

export const entryApprovalStatuses = {
  PENDING: 'PENDING',
  PUBLISHED: 'PUBLISHED',
  REJECTED: 'REJECTED'
}

// Map entry status to corresponding event name.
export const entryStatusesEventMap = {
  PENDING: 'submitted',
  PUBLISHED: 'approved',
  REJECTED: 'rejected',
  CREATED: 'created',
  EDITED: 'edited'
}

export const permissionTypes = {
  CONTRIBUTOR: 'contributor',
  CREATOR: 'creator',
  EDITOR: 'editor',
  APPROVER: 'approver',
  ADMIN: 'admin'
}

export const publishOptions = [
  { name: 'CLASSE_CONTENT', type: 'classe', icon: 'classe_upload_icon', title: 'UPLOAD_FROM_CLASSE' },
  { name: 'FILE', type: 'file', icon: 'file', title: 'UPLOAD_FILE' },
  { name: 'VIDEO_YOUTUBE', type: 'youtube', icon: 'youtube_video', title: 'UPLOAD_YOUTUBE_VIDEO' },
  { name: 'VIDEO_UPLOAD', type: 'video', icon: 'video', title: 'UPLOAD_VIDEO' },
  { name: 'URL', type: 'url', icon: 'url', title: 'UPLOAD_URL' },
  { name: 'AUDIO', type: 'audio', icon: 'sound', title: 'UPLOAD_AUDIO' }
]

export const paginationOptions = [
  10,
  25,
  50
]

export const maxNumOfCategory = 4
export const maxNumOfResults = 4

// limit file upload size to 15MB
export const uploadConfig = {
  maxUploadSize: 15000000,
  maxVimeoUploadSize: 5000000000,
  allowedFileTypes: {
    fileTypes: [
      '.docx',
      '.doc',
      '.pptx',
      '.ppt',
      '.xlsx',
      '.xls',
      '.csv',
      '.txt',
      '.pdf'
    ],
    imageTypes: ['.jpg', '.png', '.svg', '.bmp', '.gif', '.jpeg'],
    attachmentTypes: [
      '.docx',
      '.doc',
      '.pptx',
      '.ppt',
      '.xlsx',
      '.xls',
      '.csv',
      '.txt',
      '.pdf',
      '.jpg', '.png', '.svg', '.bmp', '.gif', '.jpeg'
    ],
    videoTypes: ['video/*'],
    audioTypes: ['audio/*']
  }
}

export const FileTypeIconMap = {
  csv: ['csv'],
  xlsx: ['xlc', 'xls', 'xlsb', 'xlsm', 'xlsx', 'xlw'],
  docx: ['doc', 'docm', 'docx', 'docb'],
  link: ['lnk', 'link', 'url', 'website', 'webloc'],
  pdf: ['pdf'],
  photo: [
    'arw',
    'bmp',
    'cr2',
    'crw',
    'dic',
    'dicm',
    'dcm',
    'dcm30',
    'dcr',
    'dds',
    'dib',
    'dng',
    'erf',
    'gif',
    'heic',
    'heif',
    'ico',
    'jfi',
    'jfif',
    'jif',
    'jpe',
    'jpeg',
    'jpg',
    'kdc',
    'mrw',
    'nef',
    'orf',
    'pct',
    'pict',
    'png',
    'pns',
    'psb',
    'psd',
    'raw',
    'tga',
    'tif',
    'tiff',
    'wdp'
  ],
  pptx: ['ppt', 'pptm', 'pptx', 'sldx', 'sldm'],
  txt: ['dif', 'diff', 'readme', 'out', 'plist', 'properties', 'text', 'txt']
}

export const basePanelsRoute = {
  baseLibrary: 'baseLibrary',
  contentApproval: 'contentApproval',
  staffList: 'staffList'
}

export const sideBarData = {
  tabs: {
    baseLibrary: {
      routeName: 'baseLibrary',
      textOnTab: 'LIBRARY',
      permissionTypesVisableFor: Object.values(permissionTypes)
    },
    contentApproval: {
      routeName: 'contentApproval',
      textOnTab: 'CONTENT_APPROVAL',
      permissionTypesVisableFor: [permissionTypes.CONTRIBUTOR, permissionTypes.APPROVER, permissionTypes.ADMIN]
    },
    staffList: {
      routeName: 'staffList',
      textOnTab: 'TEAM_MANAGMENT',
      permissionTypesVisableFor: [permissionTypes.ADMIN]
    }
  },
  visibleTo: [permissionTypes.CONTRIBUTOR, permissionTypes.APPROVER, permissionTypes.ADMIN]
}

export const tinyMceToolbar = 'alignright aligncenter alignleft alignjustify | bold italic underline | link code'
export const tinyMceToolbarLtr = 'alignleft aligncenter alignright alignjustify | bold italic underline | link code'
export const tinyMceFullToolbar = 'rtl ltr | code table link image | numlist bullist checklist | fontselect fontsizeselect forecolor backcolor bold italic underline | alignright aligncenter alignleft alignjustify | undo redo'
export const tinyMceFullToolbarLtr = 'ltr rtl | code table link image | numlist bullist checklist | fontselect fontsizeselect forecolor backcolor bold italic underline |alignleft aligncenter alignright alignjustify | undo redo'
export const tinyMcePlugins = ['link', 'code', 'table', 'image', 'lists', 'directionality']
export const tinyMceApiKey = 'w8xc5fh7a8t4lnsffwpxrjybtku5e8e995qz7s1pjbbhssnf'

export const apiKey = 'AIzaSyBIkLCbE2M1-ToDDyCyZ9rNPAaFf4cKfRg'

export const sizeField = { SMALL: 'small', MEDIUM: 'medium', LARGE: 'large' }

export const fieldType = { PLAINTEXT: 'PLAINTEXT', RICHTEXT_TOOLBAR: 'RICHTEXT_TOOLBAR', AUTOCOMPLETE: 'AUTOCOMPLETE', ATTACHMENTS: 'ATTACHMENTS', SELECT: 'SELECT', SELECT_MULTIPLE: 'SELECT_MULTIPLE' }

export const startPipelineTimeout = 100000
export const pipelineTimeout = 20000

export const successStatus = 'success'
